import BrandPage from "../Brands";
import Dashboard from "../Dashboard";
import EditProfile from "../EditProfile";
import Layout from "../Layout/Layout";
import LocationList from "../LocationList";
import ProductsList from "../ProductList";
import Rewards from "../Rewards/Rewards";
import Sellers from "../Sellers";
import AddSeller from "../Sellers/AddSeller";
import TagsList from "../Tags";

export const routes = [
  {
    path: `/dashboard`,
    Component: <Layout children={<Dashboard />} />,
  },
  {
    path: `/location-list`,
    Component: <Layout children={<LocationList />} />,
  },
  {
    path: `${process.env.PUBLIC_URL}/admin/account`,
    Component: <Layout children={<EditProfile />} />,
  },
  {
    path: `${process.env.PUBLIC_URL}/seller/account`,
    Component: <Layout children={<EditProfile />} />,
  },
  {
    path: `${process.env.PUBLIC_URL}/brands/brands-list`,
    Component: <Layout children={<BrandPage />} />,
  },
  {
    path: `${process.env.PUBLIC_URL}/seller/seller-list`,
    Component: <Layout children={<Sellers />} />,
  },
  {
    path: `${process.env.PUBLIC_URL}/seller/add-seller`,
    Component: <Layout children={<AddSeller />} />,
  },
  {
    path: `${process.env.PUBLIC_URL}/tags/tags-list`,
    Component: <Layout children={<TagsList />} />,
  },
  {
    path: `${process.env.PUBLIC_URL}/product-list`,
    Component: <Layout children={<ProductsList />} />,
  },
  {
    path: `${process.env.PUBLIC_URL}/rewards`,
    Component: <Layout children={<Rewards />} />,
  },
];
